module.exports = __webpack_public_path__ + "img/austria.c1ca129b.svg";